<div [class.my-offers-page]="!embedded">
  @if (!embedded) {
    <app-prevention-group-header activeTab="offers"></app-prevention-group-header>
  }

  <div class="mo-header">
    <div>
      <div class="ct" style="font-size:20px">{{ 'preventionOffres.myOffers.title' | translate }}</div>
      <div class="cs">{{ 'preventionOffres.myOffers.subtitle' | translate }}</div>
    </div>
    <div class="mo-actions">
      <button class="mo-create-btn" (click)="goCreate()">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
        {{ 'preventionOffres.myOffers.createButton' | translate }}
      </button>
      <button class="btn-primary-sm" (click)="goLibrary()">{{ 'preventionOffres.myOffers.libraryButton' | translate }}</button>
      <button class="btn-tertiary-sm" (click)="goBilans()">{{ 'preventionOffres.myOffers.bilanCatalogButton' | translate }}</button>
    </div>
  </div>

  @if (!embedded && !loadError() && !loading() && !isEmpty()) {
    <div class="mo-kpi-card">
      <div class="mo-kpi-grid">
        <div class="mo-kpi-item">
          <span class="cs">{{ 'preventionOffres.myOffers.kpi.deployed' | translate }}</span>
          <span class="mo-kpi-value">{{ deployedOffersCount() }}</span>
        </div>
        <div class="mo-kpi-item">
          <span class="cs">{{ 'preventionOffres.myOffers.kpi.sitesCovered' | translate }}</span>
          <span class="mo-kpi-value">
            @if (sitesWithPreventionCount() != null) {
              {{ sitesWithPreventionCount() }} / {{ totalSiteCount() }}
            } @else {
              —
            }
          </span>
        </div>
        <div class="mo-kpi-item">
          <span class="cs">{{ 'preventionOffres.myOffers.kpi.toDeploy' | translate }}</span>
          <span class="mo-kpi-value">{{ offersToDeployCount() }}</span>
        </div>
      </div>
    </div>
  }

  @if (loadError()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.myOffers.error' | translate }}</div></div>
  } @else if (loading()) {
    <div class="card"><div class="cs" style="text-align:center;padding:40px 0">{{ 'preventionOffres.myOffers.loading' | translate }}</div></div>
  } @else if (isEmpty()) {
    <div class="card mo-empty">
      <div class="cs" style="margin-bottom:4px">{{ 'preventionOffres.myOffers.emptyTitle' | translate }}</div>
      <div class="cs" style="margin-bottom:16px">{{ 'preventionOffres.myOffers.emptySubtitle' | translate }}</div>
      <div class="mo-actions">
        <button class="mo-create-btn" (click)="goCreate()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
          {{ 'preventionOffres.myOffers.createButton' | translate }}
        </button>
        <button class="btn-primary-sm" (click)="goLibrary()">{{ 'preventionOffres.myOffers.emptyLibraryButton' | translate }}</button>
        <button class="btn-primary-sm" (click)="goBilans()">{{ 'preventionOffres.myOffers.emptyBilanCatalogButton' | translate }}</button>
      </div>
    </div>
  } @else if (embedded) {
    <div class="card">
      @for (offer of offers(); track offer.offerId; let last = $last) {
        <div class="mo-offer-row" tabindex="0" role="link" [style.border-bottom]="last ? 'none' : '1px solid var(--bd-strong)'" (click)="goConfigure(offer.offerId, offer.name)" (keydown.enter)="goConfigure(offer.offerId, offer.name)">
          @if (photoUrl(offer); as thumb) {
            <img class="mo-offer-thumb" [src]="thumb" alt="">
          }
          <div class="mo-offer-main">
            <div class="mo-offer-name">{{ offer.name }}</div>
            <div class="cs">
              {{ (offer.bilanCount > 1 ? 'preventionOffres.myOffers.bilanCountPlural' : 'preventionOffres.myOffers.bilanCountSingular') | translate: { count: offer.bilanCount } }}
              · {{ offer.activeSiteCount }}/{{ totalSiteCount() }} {{ 'preventionOffres.myOffers.sitesLabel' | translate }}
            </div>
            <div class="mo-offer-price">{{ priceSummary(offer) }}</div>
          </div>
          <button class="btn-ps-sm" style="flex-shrink:0">{{ 'preventionOffres.myOffers.configureButton' | translate }}</button>
        </div>
      }
    </div>
  } @else {
    @for (offer of offers(); track offer.offerId) {
      <div class="card mo-offer-card">
        <div class="mo-offer-content">
          @if (photoUrl(offer); as thumb) {
            <img class="mo-offer-photo" [src]="thumb" [attr.alt]="offer.name">
          } @else {
            <div class="mo-offer-photo mo-offer-photo--placeholder">
              <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="var(--p)" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="opacity:0.65"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M21 15l-5-5L5 21"/></svg>
            </div>
          }
          <div class="mo-offer-main">
            <div class="mo-offer-name">{{ offer.name }}</div>
            <div class="cs">
              {{ (offer.bilanCount > 1 ? 'preventionOffres.myOffers.bilanCountPlural' : 'preventionOffres.myOffers.bilanCountSingular') | translate: { count: offer.bilanCount } }}
              · {{ offer.activeSiteCount }}/{{ totalSiteCount() }} {{ 'preventionOffres.myOffers.sitesLabel' | translate }}
            </div>
            <div class="mo-offer-price-row">
              <span class="mo-offer-price">{{ priceSummary(offer) }}</span>
              <span class="badge deployment-badge" [class]="'status-' + deploymentStatus(offer)">
                {{ ('preventionOffres.myOffers.deploymentStatus.' + deploymentStatus(offer)) | translate }}
              </span>
            </div>
          </div>
        </div>
        <div class="mo-offer-actions">
          <button class="btn-ps-sm" (click)="goConfigure(offer.offerId, offer.name)">{{ 'preventionOffres.myOffers.configureButton' | translate }}</button>
          <button type="button"
                  class="offer-delete-btn"
                  [attr.aria-label]="'preventionOffres.myOffers.archive.button' | translate"
                  [attr.title]="'preventionOffres.myOffers.archive.button' | translate"
                  (click)="openArchiveConfirm(offer, $event)">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="var(--rd)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>
          </button>
        </div>
      </div>
    }
  }

  @if (archiveTarget()) {
    <app-confirm-modal
      [title]="'preventionOffres.myOffers.archive.confirmTitle' | translate"
      [message]="archiveConfirmMessage()"
      [confirmText]="'preventionOffres.myOffers.archive.confirmButton' | translate"
      [cancelText]="'preventionOffres.myOffers.archive.cancelButton' | translate"
      [loading]="archiving()"
      [errorMessage]="archiveErrorMessage()"
      (confirm)="confirmArchive()"
      (cancel)="closeArchiveConfirm()">
    </app-confirm-modal>
  }
</div>
